import { apiJson } from "@/services/api";

// Tipos de destinatario: "carga" (reporte de carga de imágenes) y "gs1" (reporte diario de GS1).
const state = {
  destinatarios: [],
};

const mutations = {
  setDestinatarios(state, lista) {
    state.destinatarios = lista;
  },
};

const actions = {
  async guardarDestinatario({ dispatch }, { correo, id, tipo = "carga" }) {
    try {
      if (id) {
        await apiJson("PUT", `/destinatarios/${id}`, { email: correo });
      } else {
        await apiJson("POST", "/destinatarios", { email: correo, tipo });
      }
    } catch (e) {
      throw { code: e.code || "Error PIMG-10", msg: e.msg || "Ocurrió un error al guardar. Inténtalo más tarde." };
    }
    await dispatch("consultarDestinatarios", tipo);
  },
  async consultarDestinatarios({ commit }, tipo = "carga") {
    const res = await apiJson("GET", `/destinatarios?tipo=${encodeURIComponent(tipo)}`);
    commit("setDestinatarios", res.data);
  },
  async borrarDestinatario({ dispatch }, { id, tipo = "carga" }) {
    try {
      await apiJson("DELETE", `/destinatarios/${id}`);
    } catch (e) {
      throw { code: "Error PIMG-12", msg: "Ocurrió un error al eliminar. Inténtalo más tarde." };
    }
    await dispatch("consultarDestinatarios", tipo);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
